// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const Heading = ({ size, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      stroke={stroke}
      strokeWidth='2px'
    >
      <line x1='4' y1='28.97' x2='44' y2='28.97' />
      <line x1='4' y1='42.31' x2='24' y2='42.31' />
      <path d='M16.88,21.71h-1.99v-8.06H5.87v8.06h-1.99V4.58h1.99v7.29h9.02v-7.29h1.99v17.13Z' />
    </svg>
  );
};
